"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemoryStorage = void 0;
var _base = require("./base");
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const globalMap = new Map();
class MemoryStorage extends _base.BaseStorage {
  constructor(options) {
    super(options);
    this.map = options !== null && options !== void 0 && options.sharedContext ? globalMap : new Map();
  }
  set(key, value) {
    const suffixedKey = this.getSuffixedKey(key);
    this.map.set(suffixedKey, value);
  }
  get(key) {
    const suffixedKey = this.getSuffixedKey(key);
    return this.map.get(suffixedKey) || '';
  }
  delete(key) {
    const suffixedKey = this.getSuffixedKey(key);
    this.map.delete(suffixedKey);
  }
}
exports.MemoryStorage = MemoryStorage;